import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { BackNavigation } from "../../components/shared";
import TaskScreen from "../../components/task/screens/TaskScreen";
import { RootState, AppDispatch } from "../../store";
import { getTask, resetSelectTask } from "../../store/reducers/tasks";



const TaskPage = () => {
  const { taskId } = useParams<{ taskId: string }>();
  const { selectedTask } = useSelector((state: RootState) => state.tasks);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!taskId) return;
    dispatch(getTask(taskId));
    return () => {
      dispatch(resetSelectTask());
    };
  }, [taskId]);

  return (
    <div className="h-full max-w-6xl">
      <BackNavigation title={selectedTask?.type || "Task Detail"} />
      {selectedTask && <TaskScreen task={selectedTask} />}
    </div>
  );
};

export default TaskPage;